<template>
  <v-flex
    xs12
    md12
    sm12
    lg12
  >
    <v-layout
      class="input-border"
    >
      <v-flex
        class="shrink"
        pl-1
        my-1
      >
        <div
          class="image-picker"
          id="image-picker"
        >
          <v-img
            contain
            :src="(this.selectedItem && (isBusinessLogoAvailable || isBusinessLogoUploading || isLeadImage)) ? this.selectedItem.url : placeholderCreativeLogo"
            class="image-preview"
          />
        </div>
      </v-flex>
      <v-flex
        xs5
        sm4
        md5
        lg5
        py-1
        class="image-picker-code body-1"
        :class="{'pl-3': $vuetify.breakpoint.xsOnly, 'ml-2': $vuetify.breakpoint.smAndUp, 'ml-1': $vuetify.breakpoint.mdOnly, 'ml-4': $vuetify.breakpoint.lgAndUp}"
      >
        <span class="truncate" v-if="isBusinessLogoAvailable || isBusinessLogoUploading || isLeadImage"> {{ textTruncate(getImageName(this.selectedItemName ? this.selectedItemName : this.selectedItem.url), 30) }} </span>
        <span class="truncate" v-else> {{ $t('message.bizgainOnboarding.noImage') }} </span>
      </v-flex>
      <v-divider
        :class="{'ml-1': $vuetify.breakpoint.xsOnly, 'ml-2': $vuetify.breakpoint.smAndUp}"
        inset
        vertical
      />
      <v-layout
        align-center
        justify-center
        :class="{'pr-3 ml-1': $vuetify.breakpoint.xsAndDown, 'mr-4': $vuetify.breakpoint.smAndDown, 'pr-0': $vuetify.breakpoint.smAndUp, 'pr-4': $vuetify.breakpoint.mdAndUp, 'pr-4': $vuetify.breakpoint.lgAndUp}"
      >
        <v-flex
          xs6
          sm7
          md6
          lg6
          :class="{'mr-2': !hasSelectedImageChanged}"
        >
          <v-progress-circular
            v-show="hasSelectedImageChanged"
            class="ml-4"
            indeterminate
            size="25"
            width="2"
            color="primary"
          />
          <business-images
            @setImage="setImage"
            @logoSelected="setImage"
            @initialize="enableBusinessImageModal"
            :is-image-uploading="false"
            :is-small-suggestion="false"
            :is-stock-image-set="isLeadImage"
            :is-google-map-image-set="isLeadImage"
            ref="businessImage"
            v-show="!hasSelectedImageChanged"
          >
            <template v-slot:open-dialog>
              <span class="upload-image" v-if="(!isLeadImage && (!isBusinessLogoAvailable || !isBusinessLogoUploading))">
                <v-icon color="primary" dense>
                  upload
                </v-icon>
                <span class="pl-0 pr-3 text-primary">
                  {{ $t('message.bizgainOnboarding.upload') }}
                </span>
              </span>
              <span class="edit-image" v-else>
                <v-icon color="primary" dense>
                  edit
                </v-icon>
                <span class="pl-0 pr-3 text-primary">
                  {{ $t('message.bizgainOnboarding.change') }}
                </span>
              </span>
            </template>
          </business-images>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-flex>
</template>
<script>
import {
  VLayout,
  VFlex,
  VImg,
  VProgressCircular,
  VIcon,
  VDivider
} from 'vuetify/lib';
import { textTruncate } from 'Helpers/helpers';
import { ApiService } from '../../../services/apiService';
import { imageTypes } from 'Features/bizgainOnboarding/constants';
import { bizgainConfig, businessImageType } from 'Features/bizgainOnboarding/constants';
import { mapActions, mapGetters } from 'vuex';
import uuidv4 from 'uuid/v4';
const { uploadImage, addRoimaticImages } = new ApiService();
import { createImageFormDataRequest } from 'Features/bizgainOnboarding/helpers/commonHelper';
import BusinessImages from 'Features/bizgainOnboarding/components/BusinessImages';
import Bugsnag from '@bugsnag/js';
export default {
  props: ['items', 'type', 'loader', 'selectedTemplateId', 'disabled', 'isLeadImage'],
  data() {
    return {
      change: false,
      imageFile: null,
      selectedItem: {
        url: ''
      },
      selectedItemName: '',
      textTruncate,
      isUploading: false,
      hasSelectedImageChanged: true,
      placeholderCreativeLogo: bizgainConfig.placeholderCreativeLogo,
      isBusinessLogoAvailable: false,
      isBusinessLogoUploading: false
    };
  },
  mounted(){
    if(!this.isInAppCampaign){
      this.isBusinessLogoAvailable = this.businessDetails && this.businessDetails.isBusinessLogoAvailable;
    }
    else{
      this.isBusinessLogoAvailable = this.roimaticConfiguration && this.roimaticConfiguration.isBusinessLogoAvailable;
    }
  },
  methods: {
    ...mapActions(['updateCreativeLoader', 'patchBusinessDetails', 'updateMessage']),
    getImageName(imageName, imageSource = null) {
      if(imageSource === businessImageType.GoogleMyBusiness){
        return imageName.split('?').pop();
      }
      else if (imageName && this.isValidHttpUrl(imageName)){
        // adding this to handle if imageName is an Url
        return imageName.split('/').pop();
      }
      else if (imageName && imageName.includes('_')) {
        return imageName.split('_') && imageName.split('_')[1];
      }
      return imageName;
    },
    enableBusinessImageModal(){
      this.hasSelectedImageChanged = false;
    },
    async setImage(image, isCustomUpload){
      var imageData = { name: null, imageFile: null, imageUrl: null };
      this.hasSelectedImageChanged = true;
      this.$emit('image-process', true);
      if(isCustomUpload) {
        imageData.name = image.name;
        imageData.imageFile = image;
        imageData.imageSource = businessImageType.CustomUpload;
      }
      else if(image.imageSource == businessImageType.StockImage){
        imageData.name = image.name;
        imageData.imageUrl = image.url;
        imageData.imageSource = image.source;
        imageData.downloadLink = image.downloadLink;
      }
      else{
        imageData.name = this.getImageName(image.url, image.imageSource);
        imageData.imageUrl = image.url;
      }

      this.selectedItemName = imageData.name;
      if(this.type == imageTypes.logo){
        await this.uploadLogo(imageData);
      }
      else{
        await this.uploadLeadImage(imageData);
      }
      this.hasSelectedImageChanged = false;
    },
    async uploadLogo(image) {
      this.updateCreativeLoader({ logo: true });
      var uploadLogoData = null;
      let templates = this.businessDetails && this.businessDetails.creativeDetail && this.businessDetails.creativeDetail.templates;
      let selectedTemplateId = this.$route.params.id ? this.$route.params.id : this.businessDetails.creativeDetail.selectedTemplateId;
      let logoFormData = createImageFormDataRequest(
        this.businessDetails.sessionId,
        selectedTemplateId,
        image.imageFile,
        image.imageUrl,
        this.type,
        image.name
      );
      try{
        let response = await uploadImage(logoFormData);

        if (response) {
          let uniqueId = uuidv4();
          uploadLogoData = {
            id: response.data.templateId,
            type: this.type,
            name: response.data.imageDetail.url.split('/').pop(),
            url: response.data.imageDetail.url,
            height: response.data.imageDetail.dimension.height,
            width: response.data.imageDetail.dimension.width,
            selectedColorPalette: response.data.selectedColorPalette,
            suggestedColorPalettes: response.data.suggestedColorPalettes,
            originalLogoDetails: response.data.originLogoDetails,
            uniqueId
          }
        }

        if(image.imageSource == businessImageType.CustomUpload){
        // Taking first template id for the separate upload image call to avoid multiple calls for each template
          await this.addCustomUploadedImages(image, templates[0].id, response);
        }
        this.$emit('uploadedLogos', uploadLogoData);
        this.isUploading = false;
        this.isBusinessLogoUploading = true;
      }
      catch(error){
        this.isUploading = false;
        this.isBusinessLogoUploading = false;
        this.updateMessage({ type: 'error', message: this.$tc('message.bizgainOnboarding.failedToApplySelectedImage') });
        Bugsnag.notify(error);
      }
    },
    async uploadLeadImage(image) {
      var stockImageDownloadLink = null;
      this.updateCreativeLoader({ photo: true });
      var imageSrc = businessImageType.Default;
      if(image.imageSource == businessImageType.StockImage){
        imageSrc = image.imageSource;
        stockImageDownloadLink = image.downloadLink;
      }
      let leadImageFormData = createImageFormDataRequest(
        this.businessDetails.sessionId,
        this.$route.params.id ? this.$route.params.id : this.businessDetails.creativeDetail.selectedTemplateId,
        image.imageFile,
        image.imageUrl,
        this.type,
        image.name,
        imageSrc,
        stockImageDownloadLink
      );
      try{
        let response = await uploadImage(leadImageFormData);
        let item = {
          type: this.type,
          name: response.data.imageDetail.url.split('/').pop(),
          url: response.data.imageDetail.url,
          height: response.data.imageDetail.dimension.height,
          width: response.data.imageDetail.dimension.width
        };
        this.$emit('add', item);
        if(image.imageSource == businessImageType.CustomUpload){
          var templateId = this.$route.params.id ? this.$route.params.id : this.businessDetails.creativeDetail.selectedTemplateId;
          await this.addCustomUploadedImages(image, templateId);
        }
        this.isUploading = false;
      }
      catch(error){
        this.isUploading = false;
        this.updateMessage({ type: 'error', message: this.$tc('message.bizgainOnboarding.failedToApplySelectedImage') });
        Bugsnag.notify(error);
      }
    },
    changeItem(item) {
      this.$emit('update', item);
    },
    async addCustomUploadedImages(image, templateId, uploadResponse = null) {
      if(image.imageSource == businessImageType.CustomUpload){
        if(!uploadResponse)
        {
          var requestData = createImageFormDataRequest(
            this.businessDetails.sessionId,
            templateId,
            image.imageFile,
            image.imageUrl,
            this.type,
            image.name
          );

          uploadResponse = await uploadImage(requestData);
        }

        var uploadImageData = {};
        if(this.type == imageTypes.logo){
          var dimension = uploadResponse.data.originLogoDetails.dimension.width + 'x' + uploadResponse.data.originLogoDetails.dimension.height;
          var uploadImageData = {
            imageUrl: uploadResponse.data.originLogoDetails.url,
            dimensions: dimension,
            type: imageTypes.logo
          }
        }
        else{
          var dimension = uploadResponse.data.originLeadImageDetails.dimension.width + 'x' + uploadResponse.data.originLeadImageDetails.dimension.height;
          var uploadImageData = {
            imageUrl: uploadResponse.data.originLeadImageDetails.url,
            dimensions: dimension,
            type: imageTypes.lead
          }
        }

        if(this.businessProfileId){
          var requestData = {
            imageName: image.name,
            imageUrl: uploadImageData.imageUrl,
            imageType: uploadImageData.type
          }
          var uploadImageData = await addRoimaticImages(this.businessProfileId, requestData);
        }
        else{
          this.newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
          this.newBusinessDetails.uploadedImages.push(uploadImageData);
          let payload = {
            sessionId: this.businessDetails.sessionId,
            oldBusinessDetails: this.businessDetails,
            newBusinessDetails: this.newBusinessDetails
          };
          await this.patchBusinessDetails(payload);
        }
        this.$refs.businessImage.addCustomUploadedImage(uploadImageData);
      }
    },
    isValidHttpUrl(string) {
      // https://stackoverflow.com/a/43467144
      let url;
      try {
        url = new URL(string);
      } catch (_) {
        return false;
      }
      return url.protocol === 'http:' || url.protocol === 'https:';
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'businessProfileId', 'businessLogo', 'isBusinessLogoModalEnabled', 'isInAppCampaign', 'roimaticConfiguration'])
  },
  components: {
    VLayout,
    VFlex,
    VImg,
    VProgressCircular,
    VIcon,
    VDivider,
    BusinessImages
  },
  watch: {
    items: {
      handler() {
        if (this.items && this.items.length > 0) {
          if (!this.selectedItem) {
            let templates = this.businessDetails.creativeDetail.templates;
            if (Array.isArray(templates) && templates.length > 0) {
              let selectedTemplate = templates.find(x => x.id == this.selectedTemplateId);
              if (selectedTemplate && selectedTemplate.hasOwnProperty('logo') && selectedTemplate.hasOwnProperty('logo')) {
                if (this.type == imageTypes.logo) {
                  this.selectedItem = this.items.find(x => x.name == selectedTemplate.logo.url.split('/').pop());
                } else {
                  this.selectedItem = this.items.find(x => x.name == selectedTemplate.leadImage.url.split('/').pop());
                }
                if(!this.selectedItem){
                  this.selectedItem = this.items[0];
                }
              }
            }
          } else if (this.type == imageTypes.lead || this.type == imageTypes.logo){
            var imgType = this.type == imageTypes.lead ? 'leadImage' : 'logo';
            var selectedtemplate = this.businessDetails.creativeDetail.templates.find(x => x.id == this.selectedTemplateId);
            var selectedTemplateName = selectedtemplate[imgType] && selectedtemplate[imgType].url && selectedtemplate[imgType].url.split('/').pop();
            var item;
            if (this.selectedItemName){
              // this is when user has selected a new image
              item = this.items.find(x => x.name == selectedTemplateName && x.name == this.selectedItemName);
            }
            else{
              // this condition is to set image in IMAGEPICKER to the image in template
              item = this.items.find(x => x.name == selectedTemplateName);
            }
            if (item){
              this.selectedItem = item;
            }
            else{
              this.selectedItem = this.items[0];
            }
          }
          else {
            this.selectedItem = this.items[0];
          }
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
.truncate{
  overflow: hidden;
  max-width: 60ch;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.image-preview{
  height: 100%;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.image-picker {
  height: 35px;
  width: 35px;
  margin-left: 2px;
}
.image-picker-code{
  line-height: 2.5;
}
::v-deep .input-border{
  border-radius: 4px;
  border: solid 0.5px var(--v-black-base);
  white-space: nowrap !important;
  overflow-x: auto !important;
  scrollbar-width: thin;
}

.text-primary {
    color: var(--v-primary-base);
}
</style>
